import React, { useEffect, useRef } from "react";
import MusicCard from "../../music-card/MusicCard";
import Styles from "./MusicPage.module.scss";
import classnames from "classnames"
import { ReactComponent as LeftIcon } from "../../../icons/extra_icons/left.svg";

interface MusicPageTypes {
    layoutType?: "default" | "inline" | 'small_inline' | "banner" | "banner";
    content: any;
    onAlbumCoverClick: (data: any) => void;
}

const MusicPage = ({ layoutType="default", content, onAlbumCoverClick }: MusicPageTypes) => {
    const divRefs: any = useRef(Array.from({ length: content.length }, () => React.createRef()));

    const handleScroll = (scrollOffset: any, index: number) => {
        if (divRefs.current[index].current != null) {
            divRefs.current[index].current.scrollLeft += scrollOffset;
        }
    };


    let ui: any = []

    const getUI = (content: any) => {
        content.map((contentItem: any, index: number) => {
            ui.push(<div className={Styles.song_category}>
                {contentItem.label && <div className={Styles.title}>{`${contentItem.label} >`}</div>}
                <div className={classnames(Styles.songs_container,contentItem.layoutType ? Styles[contentItem.layoutType] : Styles[layoutType])} >
                    {<div className={classnames(Styles.button_container, Styles.left)} onClick={() => handleScroll("-100", index)}>
                        <LeftIcon />
                    </div>}
                    <div className={classnames(Styles.songs)} ref={divRefs.current[index]} style={{ overflowX: "scroll", scrollBehavior: "smooth" }}>
                        {contentItem.options.map((song: any) => {
                            return (
                                    <MusicCard
                                    title={song.title}
                                    subText={song.subText}
                                    coverImage={song.coverImage}
                                    link={song.link}
                                    onClick={onAlbumCoverClick}
                                    layoutType={contentItem.layoutType || layoutType}
                                    key={song.id}
                                />

                            )
                        })}
                    </div>
                    <div className={classnames(Styles.button_container, Styles.right)} onClick={() => handleScroll("100", index)}>
                        <LeftIcon />
                    </div>
                </div>
            </div>)

        })

        return ui;
    }
    return (
        <div className={Styles.container}>
            {getUI(content)}
        </div>
    )
}

export default MusicPage
